// removed by extract-text-webpack-plugin
module.exports = {"block":"_2J2Is31Bo7vOOP53t9EoP7","map":"_23M2cav6TRqjIMZY7YuJdz","call-to-action":"_1UHk42aGPgtL_7WlnfbBXo","marker":"_9z1A6SODuzNYQPi2BqjFx","heading":"_1_lwKePC0LC-Z_RUsDgf4A","projects":"_3iFAyNPk6KMkJA2V06qnSq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MapLocationBlock/MapLocationBlock.module.scss
// module id = 787
// module chunks = 0